export function removeTrailingSlash(path: string): string {
	return path.endsWith('/') && path !== '/' ? path.slice(0, -1) : path
}

export function removeLeadingSlash(path: string): string {
	return path.startsWith('/') && path !== '/' ? path.substring(1) : path
}

export function addTrailingSlash(path: string): string {
	path += path.endsWith('/') ? '' : '/'
	return path
}

export function addLeadingSlash(path: string): string {
	path = (path.startsWith('/') ? '' : '/') + path
	return path
}
